import { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';
import type { RiskMapClusterCounts } from '../../components/risk-map-cluster';

export const CLUSTER_SOURCE_ID = 'regional-overview-cluster-source';

export const CLUSTER_CONFIG = {
  RADIUS: 50,
  MAX_ZOOM: 9,
  LAYER_MAX_ZOOM: 10
} as const;

const countExpression = (riskValue: number) => ['+', ['case', ['==', ['get', 'calculatedRisk'], riskValue], 1, 0]];

export const CLUSTER_PROPERTIES = {
  highCount: countExpression(RiskLevelEnum.HIGH),
  mediumCount: countExpression(RiskLevelEnum.MEDIUM),
  lowCount: countExpression(RiskLevelEnum.LOW),
  noRiskCount: countExpression(RiskLevelEnum.NO_RISK),
  notApplicableCount: countExpression(RiskLevelEnum.MISSING_CONFIG)
};

interface ClusterFeatureBucketCounts {
  highCount?: number;
  mediumCount?: number;
  lowCount?: number;
  noRiskCount?: number;
  notApplicableCount?: number;
  point_count?: number;
}

export const toRiskMapClusterCounts = (properties: ClusterFeatureBucketCounts): RiskMapClusterCounts => {
  const high = properties.highCount ?? 0;
  const medium = properties.mediumCount ?? 0;
  const low = properties.lowCount ?? 0;
  const noRisk = properties.noRiskCount ?? 0;
  const notApplicable = properties.notApplicableCount ?? 0;
  const classified = high + medium + low + noRisk + notApplicable;
  const unclassified = Math.max(0, (properties.point_count ?? classified) - classified);

  return {
    high,
    medium,
    low,
    noRisk,
    notApplicable: notApplicable + unclassified
  };
};
